<template>
  <dialogTemplate
    :widthDialog="'450px'"
    :modalAppendToBody="true"
    :appendToBody="true"
    :openDialog="openDialog"
    :classDialog="'dialogRedirect'"
    :showCloseBtn="false"
  >
    <template #body>
      <div class="flex-row flex__left">
        <i
          alt=""
          class="dialogIcon fas fa-exclamation-triangle color__yellow"
        ></i>
        <h3 class="dialogTitle margin-left-5"> WARNING !</h3>
      </div>
      <div>
        <p>{{content}}</p>
        <p>Hệ thống sẽ tự động chuyển trang trong {{countDown}} giây ...</p>
        <br/>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__center form-button__action">
        <el-button
          class="bg__yellow color__white"
          @click="backToLogin"
        >
          <!--          <i class="fas fa-backward"></i>&nbsp;-->
          Về trang đăng nhập
        </el-button>
      </div>
    </template>
  </dialogTemplate>
  <!--  <el-dialog-->
  <!--    :title="title"-->
  <!--    :visible.sync="openDialog"-->
  <!--    width="30%"-->
  <!--    :close-on-click-modal="false"-->
  <!--    :show-close="false"-->
  <!--  >-->
  <!--    <span>{{content}}</span>-->
  <!--    <span slot="footer" class="dialog-footer">-->
  <!--    <el-button @click="backToLogin()" >{{countDown}} OK</el-button>-->
  <!--  </span>-->
  <!--  </el-dialog>-->
</template>

<script>
  import authenService from "../services/authenService";
  import fcmService from "../services/fcmService";
  import constants from "../constants";
  import VueCookies from 'vue-cookies';

  export default {
    name: "DialogHandlerError",

    components: {
      dialogTemplate: () => import('./../views/common/custom-dialog.vue')
    },

    props: ["content", "openDialog", "title"],

    data() {
      return {
        countDown: 10,
      }
    },

    created() {
      this.subCountDown();
    },

    methods: {
      unSubscribeFcm(localToken) {
          return fcmService.clearSessionToken(localToken).then(() => {
            fcmService.removeDeviceToken();
          });
      },
      async backToLogin() {
        const localToken = fcmService.getFromLocalStorage();
        if (localToken) {
          await this.unSubscribeFcm(localToken);
        }
        authenService.removeToken().then(() => {
          // let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
          // let redirect_uri = encodeURIComponent(constants.SSO_LOGOUT_CALLBACK);
          VueCookies.remove("IdHash");

          // let tenantCode = '';
          // if(window.location.hostname) {
          //   tenantCode = window.location.hostname.split('.')[0];
          // }

          // window.location.href = `${// constants.BASE_SERVICE_DOMAIN + tenantCode+'.'+
          //   constants.SSO_URL_LOGOUT
          // }?client_id=${client_id}&redirect_uri=${redirect_uri}&tenant_code=${tenantCode}`;
          if (authenService.getCheckLogoutError() === 'logout'){
            authenService.removeLogoutError();
            // window.location.href = `${constants.SSO_LOGOUT_CALLBACK}`;
            let tenantCode = '';
            if(window.location.hostname) {
              tenantCode = window.location.hostname.split('.')[0];
            }
            let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
            let redirect_uri = encodeURIComponent(constants.SSO_LOGOUT_CALLBACK);
            let sessionId = encodeURIComponent(authenService.getSessionId());
            let userId = encodeURIComponent(authenService.getUSID());
            window.location.href = `${// constants.BASE_SERVICE_DOMAIN +tenantCode+'.'+
              constants.SSO_URL_LOGOUT
            }?client_id=${client_id}&redirect_uri=${redirect_uri}&tenant_code=${tenantCode}&userId=${userId}&sessionId=${sessionId}`;
          }else{
            // window.location.href = `${constants.SMART_OFFICE_CALLBACK}`;
            let tenantCode = '';
            if(window.location.hostname) {
              tenantCode = window.location.hostname.split('.')[0];
            }
            let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
            let redirect_uri = encodeURIComponent(constants.SSO_LOGOUT_CALLBACK);
            let sessionId = encodeURIComponent(authenService.getSessionId());
            let userId = encodeURIComponent(authenService.getUSID());
            window.location.href = `${// constants.BASE_SERVICE_DOMAIN +tenantCode+'.'+
              constants.SSO_URL_LOGOUT
            }?client_id=${client_id}&redirect_uri=${redirect_uri}&tenant_code=${tenantCode}&userId=${userId}&sessionId=${sessionId}`;
          }

          // window.location.href = `${
          //   constants.SSO_URL_LOGOUT
          // }?client_id=${client_id}&redirect_uri=${redirect_uri}`;
        });
      },

      subCountDown() {
        setInterval(() => {
          if (this.countDown > 1) {
            this.countDown -= 1;
          } else {
            this.backToLogin();
            this.countDown -= 1;
          }
        }, 1000)
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DialogHandlerError.vue